import * as React from "react";
const SvgPlay = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1rem"
    height="1rem"
    role="img"
  >
    <path
      d="M17.7 9.13 4.47 1.5c-.67-.38-1.5.1-1.5.87v15.28c0 .77.83 1.25 1.5.87l13.23-7.64a.996.996 0 0 0 0-1.73Z"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5px",
      }}
    />
  </svg>
);
export default SvgPlay;
